import { useSelector } from 'react-redux'

export default function useAdmin() {
  const activeJobs = useSelector(state => state.admin.activeJobs)

  return {
    activeJobs,
  }
}
